import { render, staticRenderFns } from "./custom-alert-component.vue?vue&type=template&id=db705204&scoped=true"
import script from "./custom-alert-component.vue?vue&type=script&lang=js"
export * from "./custom-alert-component.vue?vue&type=script&lang=js"
import style0 from "./custom-alert-component.vue?vue&type=style&index=0&id=db705204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db705204",
  null
  
)

export default component.exports